// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u01wug{margin-left:auto}\n._19bv19bv{padding-left:10px}\n._19pk1wug{margin-top:auto}\n._1bsb1ssb{width:50%}\n._2hwx1wug{margin-right:auto}\n._4t3i1jdh{height:9rem}\n._ca0q19bv{padding-top:10px}\n._n3td19bv{padding-bottom:10px}\n._otyr1wug{margin-bottom:auto}\n._u5f319bv{padding-right:10px}\n._y3gn1h6o{text-align:center}", ""]);
// Exports
module.exports = exports;
